import { create } from 'zustand';
import { BreadcrumbStoreType } from './types';

export const useBreadcrumbStore = create<BreadcrumbStoreType>()((set) => ({
  breadcrumbDetails: '',
  setBreadcrumbDetails: (val: string) =>
    set((state) => {
      return {
        ...state,
        breadcrumbDetails: val,
      };
    }),
  resetBreadcrumbDetails: () =>
    set((state) => {
      return {
        ...state,
        breadcrumbDetails: '',
      };
    }),
}));
